import React from "react";
import { Close } from "@mui/icons-material";
import { CircularProgress, Dialog, DialogContent, DialogTitle, IconButton, Box } from "@mui/material";
import OZGridToolbar from "../../admin/common/OZDataGrid/OZGridToolbar";
import OZDataGrid from "../../admin/common/OZDataGrid/OZDataGrid";
import { useMemo, useState } from "react";
import { STATUS_CLASS_MAP } from "../../../utils/constants";

export interface AgentStatsTableData {
    agent_id: string;
    agent_name: string;
    campign_name: string;
    skillName: string;
    priority: string;
    "Active Calls": number;
    "Customer Answered": number;
    "Customer Dialing": number;
    "Agent Answered": number;
}

interface AgentDetailsPopUpProps {
    closeAgentPopUp: () => void;
    agentStatsData: { AgentName?: string; AgentId?: string; tableData: AgentStatsTableData[]; loading: boolean, lastUpdated: string | null, AgentState?: string };
}

const AgentDetailsPopUp = React.memo(function AgentDetailsPopUp({ closeAgentPopUp, agentStatsData, }: AgentDetailsPopUpProps) {

    const [gridRef, setGridRef] = useState(null);
    const { agentStatsOpen, agentStatsLoading, lastFetchedTime, AgentState } = useMemo(() => ({ agentStatsOpen: !!agentStatsData?.AgentId, agentStatsLoading: agentStatsData?.loading || false, lastFetchedTime: agentStatsData?.lastUpdated || null, AgentState: agentStatsData?.AgentState || '' }), [agentStatsData]);

    return (
        <Dialog
            open={agentStatsOpen}
            onClose={closeAgentPopUp}
            fullWidth
            maxWidth="xl"
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: '10px',
                    minHeight: '400px',
                }
            }}
        >
            <DialogTitle sx={{ fontSize: '16px', display: 'flex', alignItems: 'center' }}>
                Agent - {agentStatsData?.AgentName}
                {AgentState && (<div style={{ marginLeft: "12px", fontSize: '12px', fontWeight: '400' }}>
                    Agent State:
                    <span style={{ marginLeft: '6px' }} className={STATUS_CLASS_MAP[AgentState]}>{AgentState}</span>
                </div>
                )}
                <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '12px', marginLeft: 2, gap: 1, fontWeight: '400' }}>
                    <span className="last-fetched-time" style={{ marginLeft: '6px' }}>Last updated at {lastFetchedTime} </span>
                    {agentStatsLoading ? <>
                        <CircularProgress style={{ marginLeft: 10 }} size={14} />
                        Refreshing Data
                    </> : null
                    }
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={closeAgentPopUp}
                    sx={{
                        position: 'absolute',
                        right: 18,
                        top: 6,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{}}>

                <>
                    <OZGridToolbar title={`Agent - Details`} rowCount={agentStatsData?.tableData.length} searchPlaceholder='Search' dataGridRef={gridRef} removeMargin={true} />
                    <OZDataGrid
                        data={agentStatsData.tableData}
                        columns={[
                            {
                                field: 'campign_name',
                                headerName: 'Campaign',
                            },
                            {
                                field: 'priority',
                                headerName: 'Campaign Priority',
                            },
                            {
                                field: 'QueueCalls',
                                headerName: 'Queue Calls',
                            },
                            {
                                field: 'Customer Dialing',
                                headerName: 'Customer Dialling',
                            }
                        ]}
                        setGridRef={setGridRef}
                    />
                </>

            </DialogContent>
        </Dialog >
    )
}, (prevProps, nextProps) => {
    // Custom comparison function to prevent unnecessary re-renders
    return (
        prevProps.agentStatsData.loading === nextProps.agentStatsData.loading &&
        prevProps.agentStatsData.AgentName === nextProps.agentStatsData.AgentName &&
        prevProps.agentStatsData.AgentId === nextProps.agentStatsData.AgentId &&
        prevProps.agentStatsData.AgentState === nextProps.agentStatsData.AgentState &&
        JSON.stringify(prevProps.agentStatsData.tableData) === JSON.stringify(nextProps.agentStatsData.tableData)
    );
});

export default AgentDetailsPopUp;
